import { render } from "./Step2Organization.vue?vue&type=template&id=092ee54e"
import script from "./Step2Organization.vue?vue&type=script&lang=js"
export * from "./Step2Organization.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__